import { inject, injectable } from 'inversify'
import {
  FetchPickedUpFeaturesUseCaseInput,
  FetchPickedUpFeaturesUseCaseOutput,
  IAppErrorFactory,
  IArticlesService,
  IFetchPickedUpFeaturesUseCase,
} from '../../types'
import symbols from '../../symbols'

@injectable()
export default class FetchPickedUpFeaturesInteractor implements IFetchPickedUpFeaturesUseCase {
  @inject(symbols.IArticlesService) private articlesService: IArticlesService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: FetchPickedUpFeaturesUseCaseInput): Promise<FetchPickedUpFeaturesUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      // 現在、fetchPickedUpFeatures メソッドは引数不要。しかし今後、データの取得数を指定することを考慮して、引数（input）を記述しておく。
      output.pickedUpFeatures = await this.articlesService.fetchPickedUpFeatures(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): FetchPickedUpFeaturesUseCaseOutput {
    return {
      pickedUpFeatures: [],
      error: null,
    }
  }
}
